import React from "react"
import { Col, Collapse, Label, Row } from "reactstrap"
import classnames from "classnames"
import moment from "moment"

const MultipleView = ({
  item,
  sethandleAccordion,
  handleAccordion,
  keyId,
  activeReportStatus,
}) => {
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  return (
    <>
      <div className="accordion p-2" id={`accordion-${keyId}`}>
        <div className="accordion-item mb-2">
          <h2 className="accordion-header" id={`heading-${keyId}`}>
            <button
              className={classnames("accordion-button", "fw-medium", {
                collapsed: handleAccordion !== keyId,
              })}
              type="button"
              onClick={() => handleOnclickAccordion(keyId)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex d-flex-justspace mobile_accordian">
                
                <div style={{ paddingRight: activeReportStatus?.id == 2 && "10px" }}>
                  Date:{" "}
                  <span className="addposition">
                    {moment(item?.timeSummaryDate).format("yyyy-MM-DD")}
                  </span>
                </div>
              </div>
            </button>
          </h2>

          <Collapse isOpen={handleAccordion === keyId}>
            {/* <>sadsad</> */}
            <div className="accordion-body">
              <div className="text-muted">
                <Row>
                  <Col md="12">
                    <div
                      className="input-static-widthteams pre-wrap"
                      style={{
                        background: "#fff",
                        marginBottom: "1.5rem",
                        minHeight: "90px",
                        borderBottomWidth: "2px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: item.reportDetail,
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  )
}

export default MultipleView
